import { call, fork, put, SagaReturnType, select, take } from "redux-saga/effects";
import slice from "./reducer";

import backOfficeMessagesApi from "../../api/apiServices/backOffice/controllers/messages/messages.api";
import { makeSelectContractorId, makeSelectLeadId } from "./selectors";

function* createMessageWatcher() {
  while (true) {
    const { payload }: ReturnType<typeof slice.actions.createMessage> = yield take(slice.actions.createMessage.type);

    const contractorId: ReturnType<typeof makeSelectContractorId> = yield select(makeSelectContractorId);
    const leadId: ReturnType<typeof makeSelectLeadId> = yield select(makeSelectLeadId);

    const { success, reject }: SagaReturnType<typeof backOfficeMessagesApi.create> = yield call(backOfficeMessagesApi.create, {
      contactType: payload.contactType,
      comment: payload.comment,
      contractorId,
      leadId,
      nextContactDate: payload.nextContactDate ? payload.nextContactDate.format("YYYY-MM-DD") : undefined,
    });

    if (success) {
      yield put(slice.actions.createMessageSuccess(success.payload));
    }

    if (reject) {
      yield put(slice.actions.createMessageReject());
    }
  }
}

export default function* createMessageModalSaga() {
  yield fork(createMessageWatcher);
}
